var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c64b13b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 2 };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "infoBox mt-4" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-3" }, null, -1));
const _hoisted_6 = { class: "mt-3" };
const _hoisted_7 = { class: "mt-3" };
const _hoisted_8 = ["value"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_10 = { key: 4 };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "You have successfully registered! We will contact you via email once we have checked and approved your registration.", -1));
const _hoisted_12 = [
    _hoisted_11
];
import { onMounted, ref, watch } from "vue";
import { doApiAction } from "@/core/api";
import { apiPartnerOnboarding } from "../api";
import { CONFIG } from "@/core/config";
import PartnerUserOnboardingFormProfilePage from "./PartnerUserOnboardingFormProfilePage.vue";
import PartnerUserOnboardingFormDocumentsPage from "./PartnerUserOnboardingFormDocumentsPage.vue";
import PartnerOnboardingFormTermsPage from "./PartnerOnboardingFormTermsPage.vue";
import PartnerOnboardingFormTutorialsPage from "./PartnerOnboardingFormTutorialsPage.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerUserOnboardingForm',
    props: {
        invite: {}
    },
    setup(__props) {
        const props = __props;
        const savedStateLoading = ref(true);
        const formState = ref({
            request: {
                profile: {
                    email: "",
                    phone: "",
                    displayName: "",
                    jobTitle: "",
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    address: {
                        number: "",
                        street: "",
                        city: "",
                        state: "GA",
                        postalCode: "",
                        country: "United States"
                    },
                    workBadge: undefined,
                    stateId: undefined,
                    signature: undefined,
                }
            },
            viewedTerms: [],
            viewedTutorials: [],
            activePage: 'profile',
        });
        const pageProgressAmounts = {
            'profile': 15,
            'documents': 50,
            'terms': 75,
            'tutorials': 90
        };
        onMounted(() => {
            const savedState = localStorage[`partnerOnboarding.partnerUser.${props.invite.id}`];
            if (savedState) {
                const savedStateJson = JSON.parse(savedState);
                if (savedStateJson && savedStateJson.activePage != 'completed') {
                    console.log("Loaded form state", savedStateJson);
                    formState.value = savedStateJson;
                }
            }
            savedStateLoading.value = false;
        });
        const inProgressAction = ref(null);
        watch([formState], () => {
            localStorage[`partnerOnboarding.partnerUser.${props.invite.id}`] = JSON.stringify(formState.value);
        }, { deep: true });
        const proceedTo = (page) => {
            formState.value.activePage = page;
            window.scrollTo(0, 0);
        };
        const submitForm = () => {
            doApiAction(inProgressAction, 'submitForm', "Successfully registered!", "Failed to register", () => __awaiter(this, void 0, void 0, function* () {
                yield apiPartnerOnboarding.createPartnerUser(props.invite, formState.value.request);
                formState.value.activePage = 'completed';
            }));
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            return (savedStateLoading.value)
                ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                : (inProgressAction.value == 'submitForm')
                    ? (_openBlock(), _createBlock(_component_LoadingPage, {
                        key: 1,
                        label: "Please Wait..."
                    }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", null, [
                            _createElementVNode("h1", _hoisted_2, "Welcome to " + _toDisplayString(_unref(CONFIG).networkName) + "!", 1),
                            (formState.value.activePage != 'completed')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("p", null, [
                                            _hoisted_5,
                                            _createElementVNode("strong", null, [
                                                _createTextVNode("This page is for employees of "),
                                                _createElementVNode("em", null, _toDisplayString(_ctx.invite.partner.name), 1),
                                                _createTextVNode(" (such as case workers and case managers).")
                                            ])
                                        ]),
                                        _createElementVNode("p", _hoisted_6, "If you are not an employee at " + _toDisplayString(_ctx.invite.partner.name) + ", please ask your manager for the correct link.", 1),
                                        _createElementVNode("p", _hoisted_7, [
                                            _createTextVNode("If you have any questions about the form, please contact "),
                                            _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).helpEmail), 1),
                                            _createTextVNode(".")
                                        ])
                                    ]),
                                    _createElementVNode("progress", {
                                        class: "progress is-primary mt-5",
                                        value: pageProgressAmounts[formState.value.activePage],
                                        max: "100"
                                    }, null, 8, _hoisted_8)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _hoisted_9,
                        (formState.value.activePage == 'profile')
                            ? (_openBlock(), _createBlock(PartnerUserOnboardingFormProfilePage, {
                                key: 0,
                                modelValue: formState.value.request,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formState.value.request) = $event)),
                                onProceed: _cache[1] || (_cache[1] = ($event) => (proceedTo('documents')))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'documents')
                            ? (_openBlock(), _createBlock(PartnerUserOnboardingFormDocumentsPage, {
                                key: 1,
                                modelValue: formState.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formState).value = $event)),
                                onBack: _cache[3] || (_cache[3] = ($event) => (proceedTo('profile'))),
                                onProceed: _cache[4] || (_cache[4] = ($event) => (proceedTo('terms')))
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'terms')
                            ? (_openBlock(), _createBlock(PartnerOnboardingFormTermsPage, {
                                key: 2,
                                modelValue: formState.value.viewedTerms,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formState.value.viewedTerms) = $event)),
                                terms: _unref(CONFIG).partnerOnboarding.partnerUser.terms,
                                onBack: _cache[6] || (_cache[6] = ($event) => (proceedTo('documents'))),
                                onProceed: _cache[7] || (_cache[7] = ($event) => { formState.value.request.profile.signature = $event; proceedTo('tutorials'); })
                            }, null, 8, ["modelValue", "terms"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'tutorials')
                            ? (_openBlock(), _createBlock(PartnerOnboardingFormTutorialsPage, {
                                key: 3,
                                modelValue: formState.value.viewedTutorials,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((formState.value.viewedTutorials) = $event)),
                                tutorials: _unref(CONFIG).partnerOnboarding.partnerUser.tutorials,
                                onBack: _cache[9] || (_cache[9] = ($event) => (proceedTo('terms'))),
                                onProceed: _cache[10] || (_cache[10] = ($event) => (submitForm()))
                            }, null, 8, ["modelValue", "tutorials"]))
                            : _createCommentVNode("", true),
                        (formState.value.activePage == 'completed')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _hoisted_12))
                            : _createCommentVNode("", true)
                    ]));
        };
    }
});
